import React, { Component } from 'react';
import ChildProfileHeader from './ChildProfileHeader';
import ChildProfileMainText from './ChildProfileMainText';
import Gallery from './Gallery';
import Video from './Video';
import VideoWrapper from './VideoWrapper';


export default class AppActive extends Component {
  constructor(props) {
    super(props);
    this.getFeaturedVideoData = this.getFeaturedVideoData.bind(this);
  }

  getFeaturedVideoData() {
    // TODO: Move Some Of This Logic Into The App.js
    const { mediaData } = this.props;

    if (!mediaData || !mediaData.featuredVideoMedia || !mediaData.featuredVideoMedia.length) {
      return {};
    }

    const [ selectedMediaVideo ] = mediaData.featuredVideoMedia.filter(media => media.format ===  "web");

    if (!selectedMediaVideo) {
      return {};
    }

    return {
      videoUrl: selectedMediaVideo.url
    };
  }

  render() {
    const { getFeaturedVideoData } = this;
    const { childData, mediaData, rflData } = this.props;
    const emailallowed = this.props.appData.emailallowed;
    const { videoUrl=null } = getFeaturedVideoData();
 
    return (
      <div className="App AppActive">
        <ChildProfileHeader childData={childData} rflGroup={rflData.group} emailallowed={emailallowed}/>
        <ChildProfileMainText 
          title={rflData.title} 
          text={rflData.text}
        />
        <VideoWrapper visible={!!videoUrl} className="FeaturedVideo">
          <Video url={videoUrl} type="ChildMedia" />
        </VideoWrapper>
        <Gallery visible={true} media={mediaData} childData={childData} />
      </div>
    );
  }
}